module.exports = __webpack_public_path__ + "static/fipcgreystar1-66943224586fb7ef6bd3b320c13087ed.jpeg";